import { createFileRoute } from '@tanstack/react-router'
import { LegacyLocaleShim } from '~/components/marketing/legacy-locale-shim'
import { MarketingHomePage } from '~/components/marketing/marketing-home-page'

const SITE_URL = 'https://planno.app'
const CANONICAL = '/'

export const Route = createFileRoute('/pt/')({
  component: PtHomeShim,
  head: () => ({
    links: [{ href: `${SITE_URL}${CANONICAL}`, rel: 'canonical' }],
    meta: [{ content: 'noindex,follow', name: 'robots' }],
  }),
})

function PtHomeShim() {
  return (
    <LegacyLocaleShim canonicalPath={CANONICAL}>
      <MarketingHomePage />
    </LegacyLocaleShim>
  )
}
